import {
  USERS_WITHOUT_PROJECTS_FETCH_STARTED,
  USERS_WITHOUT_PROJECTS_FETCH_SUCCEEDED,
  USERS_WITHOUT_PROJECTS_FETCH_FAILED,
  USERS_WITHOUT_PROJECTS_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  users: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case USERS_WITHOUT_PROJECTS_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case USERS_WITHOUT_PROJECTS_FETCH_SUCCEEDED:
      return {
        ...state,
        status: statuses.succeeded,
        users: action.payload
      };
    case USERS_WITHOUT_PROJECTS_FETCH_FAILED:
      return { ...state, status: statuses.failed, users: [], error: action.error };
    case USERS_WITHOUT_PROJECTS_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
